import React, {
  PropTypes,
} from 'react';
import './Card.scss';
import BckImg from '../BckImg/BckImg'

const SquareCard = (props) => {
  return (
    <div className="card__container">
      <BckImg
        className='block row align-center'
        src={props.cardBgr}
        thumb={props.thumb}
        backgroundStyle={props.backgroundStyle}>
        <div style={{ zIndex: '1' }} className="column collapse">
          {props.children}
        </div>
      </BckImg>
    </div>
  );
};

SquareCard.propTypes = {};
SquareCard.defaultProps = {};

export default SquareCard;


// const SquareCard = (props) => {
//   const CardStyle = `block row align-center card_${props.cardBgr}`;
//
//   return (
//     <div className="card__container">
//       <div className={CardStyle}>
//         <div className="column collapse">
//           {props.children}
//         </div>
//       </div>
//     </div>
//   );
// };
//
// SquareCard.propTypes = {};
// SquareCard.defaultProps = {};
//
// export default SquareCard;



// WEBPACK FOOTER //
// ./src/components/Common/Card/Card.jsx